import { render, staticRenderFns } from "./Monteria.vue?vue&type=template&id=08d57946&scoped=true"
import script from "./Monteria.vue?vue&type=script&lang=js"
export * from "./Monteria.vue?vue&type=script&lang=js"
import style0 from "./Monteria.vue?vue&type=style&index=0&id=08d57946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d57946",
  null
  
)

export default component.exports